import React from 'react';
import MatchTimelineCornersTable from './MatchTimelineCornersTable';

const MatchDetails = ({
  eventDetails, periodId, getMatchTimeDetails, matchTimelineEvents,
  eventType,
}) => {
  const {
    teamHome, teamAway, homeScore, awayScore, flagMatchEnded,
  } = eventDetails;
  const timeDetails = getMatchTimeDetails();
  return (
    <div className="timeline m-t-30">
      <div className="timeline__row">
        <div className="timeline__panel text-right panel--left">
          <div className="timeline__panel-score">{homeScore}</div>
          <div className="timeline__panel-team">{teamHome.name}</div>
        </div>
        <div className="timeline__gutter"><span>:</span></div>
        <div className="timeline__panel panel--right">
          <div className="timeline__panel-score">{awayScore}</div>
          <div className="timeline__panel-team">{teamAway.name}</div>
        </div>
      </div>

      {(eventDetails?.homeCorners !== undefined && eventDetails?.awayCorners !== undefined)
        && (
          <MatchTimelineCornersTable
            eventDetails={eventDetails}
            matchTimelineEvents={matchTimelineEvents}
            eventType={eventType}
            timeDetails={timeDetails}
          />
        )}

      <div className="timeline__row m-t-20">
        <div className="timeline__timer">
          <span>{timeDetails}</span>
          <div className="timeline__timer-txt-left m-r-20">
            {eventDetails.periodId === periodId.FIRST ? 'First' : 'Second'}
          </div>
          <div className="timeline__timer-txt-right m-l-20">Period</div>
        </div>
      </div>
      <div className="timeline__row m-t-20">
        <div className="timeline__status-wrap">
          <div className="timeline__status">
            {flagMatchEnded ? 'Match Ended' : 'In Progress'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchDetails;
